import Splide from "@splidejs/splide";

const hero = () => {
    const heros = document.querySelectorAll('.hero-slider');

    if (heros.length === 0) {
        return;
    }

    heros?.forEach(hero => {
        const autoplayVar = hero?.getAttribute('data-autoplay');
        console.log(autoplayVar);
        new Splide(hero, {
            type    : 'loop',
            autoplay: autoplayVar,
            interval: 5000,
            arrows  : true,
            pagination: false,
            speed   : 600
        }).mount();

        const prevArrow = hero?.querySelector('.splide__arrow--prev');
        const nextArrow = hero?.querySelector('.splide__arrow--next');

        if (prevArrow && nextArrow) {
            prevArrow.innerHTML = `
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M14.9625 9.07505L16.575 10.65L10.275 16.95L30 16.95L30 19.2L10.275 19.2L16.6125 25.5375L15 27.1125L5.9625 18.075L14.9625 9.07505Z" fill="white"/>
            </svg>
            `;
            nextArrow.innerHTML = `
            <svg width="36" height="36" viewBox="0 0 36 36" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M21.0375 26.925L19.425 25.35L25.725 19.05H6V16.8H25.725L19.3875 10.4625L21 8.88745L30.0375 17.925L21.0375 26.925Z" fill="white"/>
            </svg>
            `;
        }


    });
}

export default hero;